import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import IconWithDescription from '../index';

import './styles.scss';

/**
 * Component for displaying the icon and the tooltip
 * for a Topic Question
 * */
const APTopicQuestionIcon = ({ iconClass, popoverClass }) => {
  const tooltipContent =
    'Topic Questions are formative questions to check understanding as you teach';
  const popoverTrigger = (
    <Icon
      className={cn({ [iconClass]: !!iconClass })}
      id="topic_questions"
      height="20"
      width="20"
    />
  );

  return (
    <IconWithDescription
      className={cn({ [popoverClass]: !!popoverClass })}
      width="medium"
      trigger={popoverTrigger}
      popoverAriaLabel="Topic Question Icon"
      tooltipAriaLabel={tooltipContent}
      buttonClassName="flex items-center"
    >
      <span>{tooltipContent}</span>
    </IconWithDescription>
  );
};

APTopicQuestionIcon.displayName = 'APTopicQuestionIcon';

APTopicQuestionIcon.props = {
  // CSS class for styling the icon
  iconClass: PropTypes.string,
  // CSS class for styling the popover.
  popoverClass: PropTypes.string,
};

APTopicQuestionIcon.defaultProps = {
  iconClass: null,
  popoverClass: null,
};

export default APTopicQuestionIcon;
